var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#012234"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#2C5369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 13.25C21.3768 13.25 19.2501 15.3766 19.2501 18C19.2501 20.6234 21.3768 22.75 24.0001 22.75C26.6235 22.75 28.7501 20.6234 28.7501 18C28.7501 15.3766 26.6235 13.25 24.0001 13.25ZM20.7501 18C20.7501 16.2051 22.2052 14.75 24.0001 14.75C25.7951 14.75 27.2501 16.2051 27.2501 18C27.2501 19.7949 25.7951 21.25 24.0001 21.25C22.2052 21.25 20.7501 19.7949 20.7501 18Z",
    fill: "#EBF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8556 26.5729C32.1529 26.8614 32.16 27.3362 31.8715 27.6334L30.0383 29.5223C29.8902 29.6749 29.6843 29.7575 29.4718 29.7495C29.2593 29.7414 29.0602 29.6436 28.924 29.4802L28.0905 28.4802C27.8253 28.162 27.8683 27.6891 28.1864 27.4239C28.5046 27.1587 28.9776 27.2016 29.2428 27.5198L29.5425 27.8794L30.7951 26.5888C31.0836 26.2915 31.5584 26.2844 31.8556 26.5729Z",
    fill: "#EBF0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7748 24.5129C25.9021 24.3421 24.9686 24.25 24.0001 24.25C21.6866 24.25 19.5551 24.7759 17.9756 25.6643C16.4196 26.5396 15.2501 27.8661 15.2501 29.5L15.2501 29.602C15.2489 30.7638 15.2475 32.222 16.5265 33.2635C17.156 33.7761 18.0366 34.1406 19.2263 34.3815C20.4194 34.6229 21.9744 34.75 24.0001 34.75C26.8682 34.75 28.81 34.4961 30.1197 34.0085C31.2986 33.5697 31.9974 32.9266 32.3705 32.1172C33.7928 31.2966 34.7501 29.7601 34.7501 28C34.7501 25.3766 32.6235 23.25 30.0001 23.25C28.755 23.25 27.6218 23.7291 26.7748 24.5129ZM26.7501 28C26.7501 26.2051 28.2052 24.75 30.0001 24.75C31.7951 24.75 33.2501 26.2051 33.2501 28C33.2501 29.7949 31.7951 31.25 30.0001 31.25C28.2052 31.25 26.7501 29.7949 26.7501 28ZM25.7558 25.865C25.4323 26.5069 25.2501 27.2322 25.2501 28C25.2501 30.3893 27.0142 32.3666 29.311 32.7004C28.2402 33.0366 26.5781 33.25 24.0001 33.25C22.0259 33.25 20.5809 33.1252 19.5239 32.9113C18.4637 32.6967 17.8443 32.4022 17.4737 32.1004C16.7904 31.544 16.7501 30.8078 16.7501 29.5C16.7501 28.6487 17.3715 27.7251 18.711 26.9717C20.0269 26.2315 21.8954 25.75 24.0001 25.75C24.6062 25.75 25.1941 25.79 25.7558 25.865Z",
    fill: "#EBF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDark);
export default __webpack_public_path__ + "static/media/userDark.d33922800c24c81a9d2d6bea9d7fc41b.svg";
export { ForwardRef as ReactComponent };